module.exports = __webpack_public_path__ + "static/2-5f65dc86c7238fc5a1c99075782c148d.jpeg";